'use client';

import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Modal } from './Modal';
import { ContactForm } from '../forms/ContactForm';

interface ModalContextValue {
    openModal: () => void;
    closeModal: () => void;
}

const ModalContext = createContext<ModalContextValue | null>(null);

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
    const [open, setOpen] = useState(false);

    const openModal = useCallback(() => setOpen(true), []);
    const closeModal = useCallback(() => setOpen(false), []);

    const value = useMemo(() => ({ openModal, closeModal }), [openModal, closeModal]);

    return (
        <ModalContext.Provider value={value}>
            {children}
            <Modal open={open} onClose={closeModal}>
                <ContactForm />
            </Modal>
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const ctx = useContext(ModalContext);
    if (!ctx) throw new Error('useModal must be used within ModalProvider');
    return ctx;
};
